/**
 * Created by JIocb on 26.06.2017.
 */
module Factive.Core {
    import Signal = Factive.Core.Signal.Signal;

    export class Howler2SoundManager implements ISoundManager {
        private _availableResources: {};
        private _sounds: {};
        private _musics: {};
        private _freeSounds: Array<any>;
        private _freeMusics: Array<any>;
        private _howlerSound: any;
        private _howler: any;
        private _mute: boolean;
        private _soundConfig: any;
        private _cdnUrl: string;

        constructor(howlerSound: any, howler: any, soundConfig = null, cdnUrl: string) {
            this._cdnUrl = cdnUrl;
            this._soundConfig = soundConfig;
            this._howlerSound = howlerSound;
            this._howler = howler;
            this._howler.mobileAutoEnable = false;
            this._availableResources = {}; //Map storing "audio" resources for faster access.

            this._sounds = {};
            this._musics = {};
            this._freeSounds = []; //Sounds without an assigned channel.
            this._freeMusics = []; //Musics without an assigned channel.

            let that = this;
            let hidden = "hidden";

            // Standards:
            if (typeof (document as any).mozHidden != "undefined")
            {
                hidden = "mozHidden";
                document.addEventListener("mozvisibilitychange", onchange);
            }
            else if (typeof (document as any).webkitHidden != "undefined")
            {
                hidden = "webkitHidden";
                document.addEventListener("webkitvisibilitychange", onchange);
            }
            else if (typeof (document as any).msHidden != "undefined")
                {
                    hidden = "msHidden";
                    document.addEventListener("msvisibilitychange", onchange);
                }
                else if (typeof document.hidden != "undefined")
                    {
                        document.addEventListener("visibilitychange", onchange);
                    }

                    // IE 9 and lower:
                    else if ("onfocusin" in document)
                            (document as any).onfocusin = (document as any).onfocusout = onchange;
            // All others:
            //else
            window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;

            function onchange(evt) {
                var v = "visible",
                    h = "hidden",
                    evtMap = {
                        focus: v,
                        focusin: v,
                        pageshow: v,
                        blur: h,
                        focusout: h,
                        pagehide: h
                    };

                evt = evt || window.event;
                if (evt.type in evtMap) {
                    if(evtMap[evt.type] == "hidden"){
                        that.mute2(true);
                    }else{
                        that.mute2(that._mute);
                    }
                } else {
                    if(document[hidden]){
                        that.mute2(true);
                    }else{
                        that.mute2(that._mute);
                    }
                }
            }

            // set the initial state (but only if browser supports the Page Visibility API)
            if (document[hidden] !== undefined)
                onchange({
                    type: document[hidden] ? "blur" : "focus"
                });
        }

        clampRate(rate) {
            if (rate > 4.0) return 4.0;
            if (rate < 0.5) return 0.5;
            return rate;
        };

        _getFileFromSoundName (soundName) {
            if (this._availableResources.hasOwnProperty(soundName) &&
                this._availableResources[soundName].file) {
                return this._availableResources[soundName].file;
            }
            return soundName;
        }

        _storeSoundInArray (arr, sound) {
            // let length:number = arr.length;
            // for(let i:number = 0;i<length;i++) {
            //     if (arr[i] !== null && arr[i].canBeDestroyed()) {
            //         arr[i] = sound;
            //         return sound;
            //     }
            // }

            arr.push(sound);

            return sound;
        };

        private getFreeSoundByName(soundName:string):any {
            let soundTarget = null;
            let length:number = this._freeSounds.length;

            for(let i:number = 0; i < length; i++) {
                let sound = this._freeSounds[i];
                //let arr:Array<string> = sound._src.split("/");
                //let name:string = arr[arr.length - 1].split(".")[0];
                if (sound.name == soundName) {
                    soundTarget = sound;
                    break;
                }
            }


            return soundTarget;
        };

        public stopSound(soundName):void {
            let sound = this.getFreeSoundByName(soundName);
            if(sound)
            {
                sound.stop();
            }
        };

        public playSound(soundName:string, loop:boolean = false, volume:number = 1, pitch:number = 1):void {
            volume *= 100;

            let sound = this.getFreeSoundByName(soundName);
            if(sound)
            {
                sound.play();
            }
            else
            {
                let soundFile = this._getFileFromSoundName(soundName);
                volume = volume||100;
                sound = new this._howlerSound({
                    src: [soundFile], //TODO: ogg, mp3...
                    format: ['mp3'],
                    loop: loop,
                    volume: volume/100,
                    rate: this.clampRate(pitch)
                });
                sound.name = soundName;
                this._storeSoundInArray(this._freeSounds, sound).play();
            }
        };

        playSoundOnChannel (soundName, channel, loop, volume, pitch) {
            let	oldSound = this._sounds[channel];
            if (oldSound) {
                oldSound.stop();
            }

            let soundFile = this._getFileFromSoundName(soundName);

            let sound = new this._howlerSound({
                src: [soundFile], //TODO: ogg, mp3...
                format: ['mp3'],
                loop: loop,
                volume: volume/100,
                rate: this.clampRate(pitch)
            });

            sound.play();
            this._sounds[channel] = sound;
        };

        getSoundOnChannel (channel) {
            return this._sounds[channel];
        };

        playMusic (soundName, loop, volume, pitch) {
            let soundFile = this._getFileFromSoundName(soundName);

            let sound = new this._howlerSound({
                src: [soundFile], //TODO: ogg, mp3...
                format: ['mp3'],
                loop: loop,
                html5: false, //Force HTML5 audio so we don't wait for the full file to be loaded on Android.
                volume: volume/100,
                rate: this.clampRate(pitch)
            });

            this._storeSoundInArray(this._freeMusics, sound).play();
        };

        playMusicOnChannel (soundName, channel, loop, volume, pitch) {
            let	oldMusic = this._musics[channel];
            if (oldMusic) {
                oldMusic.stop();
            }

            let soundFile = this._getFileFromSoundName(soundName);

            let music = new this._howlerSound({
                src: [soundFile], //TODO: ogg, mp3...
                format: ['mp3'],
                loop: loop,
                html5: true, //Force HTML5 audio so we don't wait for the full file to be loaded on Android.
                volume: volume/100,
                rate: this.clampRate(pitch)
            });

            music.play();
            this._musics[channel] = music;
        };

        getMusicOnChannel (channel) {
            return this._musics[channel];
        };

        setGlobalVolume (volume) {
            this._howler.volume(volume/100);
        };

        getGlobalVolume () {
            return this._howler.volume()*100;
        };

        clearAll () {
            for (let i = 0;i<this._freeSounds.length;++i)  {
                if (this._freeSounds[i]) {
                    this._freeSounds[i].stop();
                }
            }
            for (let i = 0;i<this._freeMusics.length;++i)  {
                if (this._freeMusics[i]) {
                    this._freeMusics[i].stop();
                }
            }
            //this._freeSounds.length = 0;
            //this._freeMusics.length = 0;

            for (let p in this._sounds) {
                if (this._sounds.hasOwnProperty(p) && this._sounds[p]) {
                    this._sounds[p].stop();
                    delete this._sounds[p];
                }
            }
            for (let p in this._musics) {
                if (this._musics.hasOwnProperty(p) && this._musics[p]) {
                    this._musics[p].stop();
                    delete this._musics[p];
                }
            }
        }

        preloadAudio (onProgress, onComplete, resourcesType) {

            const resources = this._soundConfig[resourcesType];

            let files = [];
            for(let i = 0, len = resources.length;i<len;++i) {
                let res = resources[i];
                if ( res.file ) {
                    this._availableResources[res.name] = res;

                    res.file = this._cdnUrl + res.file;

                    if (files.indexOf(res.file) === -1) {
                        files.push(res.file);
                    }
                }
            }

            if (files.length === 0) return onComplete();

            let loaded = 0;

            let that = this;
            for(let i = 0;i<files.length;++i) {
                (function(audioFile) {
                    //console.log("Loading" + audioFile)
                    let sound = new that._howlerSound({
                        src: [audioFile], //TODO: ogg, mp3...
                        format: ['mp3'],
                        preload: true,
                        onload: (audioFile) =>{
                            //console.log("loaded" + audioFile);
                            loaded++;
                            if (loaded === files.length) {
                                //console.log("All audio loaded");
                                return onComplete();
                            }

                            onProgress(loaded, files.length);
                        },
                        onloaderror: (audioFile) =>{
                            console.log("error" + audioFile);
                        }
                    });
                })(files[i]);
            }
        }

        public play(sndName: string, volume: number = 1, loop: boolean = false): void {
            this.playSound(sndName, loop, volume, 1);
        };

        public mute2(value: boolean): void {
            if(value){
                this.setGlobalVolume(0);
            }else{
                this.setGlobalVolume(100);
            }
        };

        public mute(value: boolean): void {
            this._mute = value;
            if(this._mute){
                this.setGlobalVolume(0);
            }else{
                this.setGlobalVolume(100);
            }
        };
    }
}


// WEBPACK FOOTER //
// src/typescript/Core/Sound/Howler2SoundManager.ts